<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template #prepend>
        <v-icon icon="mdi-home" size="small" />
      </template>
    </v-breadcrumbs>

    <v-container fluid>
      <v-card rounded="xl" elevation="2">
        <v-card-title>
          <v-row>
            <v-col cols="6" class="text-h6 font-weight-bold">বিদেশ ভ্রমণ</v-col>
            <v-col cols="6" class="text-end">
              <v-btn color="secondary" size="small" class="me-3 rounded-lg" @click="openModal">
                <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
        </v-card-title>
        <v-row>
          <v-col cols="12" md="12">
            <v-table class="language-table">
              <thead>
              <tr>
                <th>দেশের নাম</th>
                <th>ভ্রমণের ধরন</th>
                <th>শুরুর তারিখা</th>
                <th>শেষের তারিখ</th>
                <th>অর্থায়নের উৎস</th>
                <th>সরকারি আদেশের তারিখ</th>
                <th>আদেশের কপি</th>
                <th width="120">অ্যাকশন</th>
              </tr>
              </thead>

              <tbody>
              <tr>
                <td colspan="8" class="text-center py-6">
                  কোন তথ্য পাওয়া যায়নি
                </td>
              </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </v-card>


      <form>
        <InsertModal ref="Modal" title="বিদেশ ভ্রমণ" :width="600">
          <template #modalBody>
            <v-row>
              <v-col cols="12">
                <v-select class="mb-3"
                    label="দেশের নাম *"
                    variant="outlined"
                    density="comfortable"
                    placeholder="দেশের নাম"
                ></v-select>

                <v-select class="mb-3"
                    label="ভ্রমণের ধরন *"
                    variant="outlined"
                    density="comfortable"
                    placeholder="ভ্রমণের ধরন বাছাই করুন"
                ></v-select>


                <v-menu v-model="tripStartDate" :close-on-content-click="false" location="bottom">
                  <template #activator="{ props }">
                    <v-text-field
                        :model-value="formatDate(form.start_date)"
                        label="শুরুর তারিখ *"
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        density="comfortable"
                        readonly
                        class="mb-3"
                        v-bind="props"
                    />
                  </template>
                  <v-date-picker style="margin-top: -20px" v-model="form.start_date" color="primary" hide-header @update:modelValue="tripStartDate = false"/>
                </v-menu>

                <v-menu v-model="tripEndDate" :close-on-content-click="false" location="bottom">
                  <template #activator="{ props }">
                    <v-text-field
                        :model-value="formatDate(form.end_date)"
                        label="শেষের তারিখ *"
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        density="comfortable"
                        readonly
                        class="mb-3"
                        v-bind="props"
                    />
                  </template>
                  <v-date-picker style="margin-top: -20px" v-model="form.end_date" color="primary" hide-header @update:modelValue="tripEndDate = false"/>
                </v-menu>

                <v-select class="mb-3"
                    label="অর্থায়নের উৎস *"
                    variant="outlined"
                    density="comfortable"
                    placeholder="অর্থায়নের উৎস বাছাই করুন"
                ></v-select>

                <v-menu v-model="govOrderDate" :close-on-content-click="false" location="bottom">
                  <template #activator="{ props }">
                    <v-text-field
                        :model-value="formatDate(form.gov_order_date)"
                        label="সরকারি আদেশের তারিখ *"
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        density="comfortable"
                        readonly
                        class="mb-3"
                        v-bind="props"
                    />
                  </template>
                  <v-date-picker style="margin-top: -20px" v-model="form.gov_order_date" color="primary" hide-header @update:modelValue="govOrderDate = false"/>
                </v-menu>

                <v-select class="mb-3"
                          label="আদেশের কপি *"
                          variant="outlined"
                          density="comfortable"
                          placeholder="আদেশের কপি বাছাই করুন"
                ></v-select>

              </v-col>
            </v-row>
          </template>
          <template #modalFooter>
            <v-row>
              <v-col cols="12">
                <v-btn color="primary" size="large" class="me-3 rounded-lg" type="submit">
                  <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
                </v-btn>
                <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
                  <v-icon start>mdi-refresh</v-icon>রিসেট
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </InsertModal>
      </form>
    </v-container>
  </div>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "ForeignTrip",

  components: {
    InsertModal
  },

  data() {
    return {
      breadcrumbs: [
        {
          title: "Dashboard",
          disabled: false,
          to: "/dashboard",
        },
        {
          title: "Foreign Trip",
          disabled: true,
        },
      ],

      tripStartDate: false,
      tripEndDate: false,
      govOrderDate: false,
      form: {
        start_date: '',
        end_date: '',
        gov_order_date: '',
      }


    };
  },
  methods: {
    openModal() {
      this.$refs.Modal.openModal()
    },
    editItem(item) {
      console.log("Edit:", item);
    },

    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {

      };
    },

    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
  }
};
</script>

<style scoped>
</style>
